import type { AufgabeAbschliessenModel } from '../model';
import type { AufgabeErgebnis } from './constants';

export const toBearbeiterFullName = (aufgabe: AufgabeAbschliessenModel) => {
  return aufgabe?.protokoll && aufgabe.protokoll.length > 0 ?
    aufgabe.protokoll[0]?.akteur :
    'Unbekannter Nutzer';
};

export const toBearbeitungsDate = (aufgabe: AufgabeAbschliessenModel) => {
  return aufgabe?.protokoll && aufgabe.protokoll.length > 0 ?
    aufgabe.protokoll[0]?.erstellt :
    '';
};

export const getErgebnisoptionen = (ergebnis: AufgabeErgebnis | null, aufgabe: AufgabeAbschliessenModel) => {
  switch (ergebnis) {
    case 'Erfolgreich':
      return getOptionenMitStandardOptionen(aufgabe.erfolgreicheAntworten);
    case 'Erfolglos':
      return getOptionenMitStandardOptionen(aufgabe.erfolgloseAntworten);
    case 'Zwischenergebnis':
      return getOptionenMitStandardOptionen(aufgabe.ungewisseAntworten);
    default:
      return [];
  }
};

function getOptionenMitStandardOptionen(optionen: string[]) {
  const SONSTIGES = 'Sonstiges (bitte Kommentar angeben)';

  if (optionen.includes(SONSTIGES)) {
    return optionen;
  }
  return [...optionen, SONSTIGES];
}
